module.exports = __webpack_public_path__ + "static/img/2.fa47fc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Nya/2.jpg
// module id = 0wpF
// module chunks = 0